<template>
  <page-component
    id="webhouseholdselection"
    :header="`Household Selection for ${firstname}`">
    <p>Choose the Household or Organization you want to login with.</p>
    <form
      ref="form"
      :action="baseHref + 'login.html'"
      method="post">
      <input
        type="hidden"
        name="Action"
        value="process" />
      <input
        type="hidden"
        name="SubAction"
        value="" />
      <input
        type="hidden"
        name="hhselect_householdnumber"
        :value="householdNumber" />
      <input
        type="hidden"
        name="_csrf_token"
        :value="crsf" />
      <div id="households">
        <button
          v-for="household in households"
          :key="household.householdNumber"
          :id="'household_' + household.householdNumber"
          type="button"
          class="button household"
          :disabled="processing"
          @click="onClickSelectHousehold(household)">
          <div class="household-header">
            <strong>{{ calcHouseholdName(household) }}</strong>
          </div>
          <div class="household-number">
            <strong>Household Number:</strong>
            <span>{{ household.householdNumber }}</span>
          </div>
          <div class="household-icon">
            <span class="household-icon-text">{{
              calcHouseholdIcon(household)
            }}</span>
          </div>
        </button>
      </div>
    </form>
  </page-component>
</template>

<script>
export default {
  name: 'HouseholdSelection',
  props: {
    firstname: String,
    lastname: String,
    households: Array
  },
  data() {
    return {
      crsf: App.settings.CSRFToken,
      baseHref: App.settings.BaseHref,
      householdNumber: 0,
      processing: false
    }
  },
  methods: {
    calcHouseholdName(household) {
      if (household.orgName) {
        return household.orgName
      } else if (household.firstName && household.lastName) {
        return household.lastName + ', ' + household.firstName
      } else if (household.lastName) {
        return household.lastName
      }
      return 'Household #' + household.householdNumber
    },

    calcHouseholdIcon(household) {
      let name = ''
      if (household.orgName) {
        name = household.orgName
      } else if (household.firstName && household.lastName) {
        name = household.firstName + ' ' + household.lastName
      } else if (household.lastName) {
        name = household.lastName
      }

      if (!name) {
        return '&nbsp;'
      }

      const parts = name.split(' ')
      if (parts.length >= 2) {
        return parts[0].substring(0, 1) + parts[1].substring(0, 1)
      }
      return parts[0].substring(0, 2)
    },

    onClickSelectHousehold(household) {
      this.processing = true
      this.householdNumber = household.householdNumber
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.submit()
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
@import '../../assets/css/abstract/variables';
@import '../../assets/css/abstract/mixins';

#webhouseholdselection {
  p {
    margin: 0;
    padding: 0;
    padding-top: 24px;
  }

  #households {
    display: flex;
    flex-direction: row;
    padding: 12px 0;
    flex-wrap: wrap;

    .household {
      margin: 6px;
      display: flex;
      padding: 24px 12px;
      max-width: calc(50% - 12px);
      height: auto;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      border-radius: 12px;
      box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.2);

      .household-header {
        font-size: 180%;
      }

      .household-number {
        font-size: 90%;

        span {
          margin-left: 6px;
        }
      }

      .household-icon {
        width: 76px;
        height: 76px;
        display: flex;
        background: @secondary-color;
        border-radius: 50%;
        justify-content: center;
        align-items: center;
        border: 1px solid rgba(192, 192, 192, 0.5);

        .household-icon-text {
          font-size: 200%;
          text-transform: uppercase;
          color: @secondary-text-color;
          font-weight: 700;
        }
      }
    }
  }
}

@media @phone-down {
  #webhouseholdselection #households {
    flex-direction: column;
  }

  #webhouseholdselection #households .household {
    max-width: 100%;
    margin: 12px 0;
  }
}
</style>
